<template>
    <psi-dialog
        headingColor="primary"
        icon="mdi-scale-balance"
        :title="`National Public Data Case Details`"
        hide-actions
        @close="$emit('close')"
    >
        <v-row class="justify-center">
            <v-col cols="9">
                <case-details-list
                    :caseDetails="caseDetails"
                ></case-details-list>
            </v-col>
        </v-row>
    </psi-dialog>
</template>

<script>
export default {
    name: "screen-npd-case-details",
    components: {
        CaseDetailsList: () => import("./CaseDetailsList.vue"),
    },
    props: {
        caseDetails: {
            type: Object,
            required: true,
        },
    },
};
</script>

